import Naluri from '~/common/api/naluri';
import { delay } from '~/common/utils';
import {
  MODULES_UPDATE_NOTES_BEGIN,
  MODULES_UPDATE_NOTES_SUCCESS,
  MODULES_UPDATE_NOTES_FAILURE,
  MODULES_UPDATE_NOTES_DISMISS_ERROR,
} from './constants';

export function updateNotes (moduleId, answerId, notes) {
  return (dispatch, getState) => {
    dispatch({ type: MODULES_UPDATE_NOTES_BEGIN })

    delay(function(){
      Naluri.put(`/api/expert/modules/${moduleId}/answers/${answerId}`, { notes })
      .then((res) => {
        dispatch({ type: MODULES_UPDATE_NOTES_SUCCESS })
      })
    }, 1000)
}}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUpdateNotesError() {
  return {
    type: MODULES_UPDATE_NOTES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MODULES_UPDATE_NOTES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateNotesPending: true,
        updateNotesError: null,
      };

    case MODULES_UPDATE_NOTES_SUCCESS:
      // The request is success
      return {
        ...state,
        updateNotesPending: false,
        updateNotesError: null,
      };

    case MODULES_UPDATE_NOTES_FAILURE:
      // The request is failed
      return {
        ...state,
        updateNotesPending: false,
        updateNotesError: action.data.error,
      };

    case MODULES_UPDATE_NOTES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateNotesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/modules/redux/updateNotes.js